import axios from 'axios'
import constants from './constants'

import CAS from './CAS-client';

export const HTTP = axios.create({
  baseURL: constants.CONSULTAS_BACKEND_URL
});

HTTP.interceptors.request.use(config => {
  let ticket = sessionStorage.getItem("ticket");
  config.params = {
    // adding default query params
    ticket: ticket,
    // spread the request's params
    ...config.params,
  };

  return config;
});

// En caso de obtener una respuesta 401, intentar validar el token
// Si el token no es válido realizar el logout
HTTP.interceptors.response.use(
    async function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          console.log(error.response.data);
          //TODO: checkTicket debe refrescar el token
          CAS.checkTicket()
              .then(response => {
                console.log(response.data);
              })
              .catch(error => {
                console.log(error.response.data);
              })
          // console.log("Error... se intenta desloguear")
          //CAS.logout();
        }
      }

      return Promise.reject(error);
    }
);

